export default __webpack_public_path__ + "static/media/CornerShots.3257cabd.gif";